/* src/modules/it/ITCenter.js */
import React, { useState } from 'react';
import ITInventory from './components/ITInventory';
import ITRequestPortal from './components/ITRequestPortal';
import MyAssets from './components/MyAssets';
import ITReporting from './components/ITReporting'; // <--- NEW IMPORT
import { ServerIcon, ClipboardListIcon, CubeIcon, ChartBarIcon } from '../../components/icons/Icons';

export default function ITCenter({ userProfile, appId }) {
    const [activeTab, setActiveTab] = useState('my_assets');
    
    // Permission Logic
    const isITAdmin = userProfile.role === 'Admin' || 
                      userProfile.department === 'IT' || 
                      userProfile.department === 'HR';

    return (
        <div className="space-y-6 animate-fadeIn">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold text-[#213368]">IT Center</h2>
                    <p className="text-sm text-gray-500">Manage assets, track inventory, and support requests.</p>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="flex space-x-1 border-b border-gray-200 overflow-x-auto">
                <TabButton 
                    id="my_assets" 
                    label="My Assets" 
                    icon={<CubeIcon className="h-4 w-4 mr-2"/>} 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab} 
                />
                <TabButton 
                    id="requests" 
                    label="IT Helpdesk" 
                    icon={<ClipboardListIcon className="h-4 w-4 mr-2"/>} 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab} 
                />
                
                {/* Admin Tabs */}
                {isITAdmin && (
                    <>
                        <TabButton 
                            id="inventory" 
                            label="Inventory Management" 
                            icon={<ServerIcon className="h-4 w-4 mr-2"/>} 
                            activeTab={activeTab} 
                            setActiveTab={setActiveTab} 
                        />
                        {/* --- NEW REPORTING TAB --- */}
                        <TabButton 
                            id="reporting" 
                            label="Reports & Analytics" 
                            icon={<ChartBarIcon className="h-4 w-4 mr-2"/>} 
                            activeTab={activeTab} 
                            setActiveTab={setActiveTab} 
                        />
                    </>
                )}
            </div>

            {/* Content Area */}
            <div className="bg-white p-6 rounded-b-lg rounded-tr-lg shadow-sm border border-gray-200 min-h-[500px]">
                {activeTab === 'my_assets' && <MyAssets userProfile={userProfile} appId={appId} />}
                {activeTab === 'requests' && <ITRequestPortal userProfile={userProfile} appId={appId} isITAdmin={isITAdmin} />}
                {activeTab === 'inventory' && isITAdmin && <ITInventory userProfile={userProfile} appId={appId} />}
                {/* --- NEW REPORTING COMPONENT --- */}
                {activeTab === 'reporting' && isITAdmin && <ITReporting appId={appId} />}
            </div>
        </div>
    );
}

function TabButton({ id, label, icon, activeTab, setActiveTab }) {
    return (
        <button
            onClick={() => setActiveTab(id)}
            className={`flex items-center px-6 py-3 text-sm font-medium transition-colors border-b-2 rounded-t-lg whitespace-nowrap ${
                activeTab === id 
                    ? 'border-[#20BEC6] text-[#20BEC6] bg-blue-50' 
                    : 'border-transparent text-gray-500 hover:text-[#213368] hover:bg-gray-50'
            }`}
        >
            {icon}
            {label}
        </button>
    );
}